<script setup>
import { compact, values } from 'lodash';
import { ref, reactive, inject } from 'vue';
import { usuarios } from 'cifra-api-js';
import toast from '../../libs/cifra/toast';
import Overlay from '../../libs/cifra/overlay';
import IconosTipoUsuario from '../usuarios/IconosTipoUsuario.vue';
import Usuario from '../../models/Usuario';

const $I18n = inject('I18n');

defineProps({
  formAction: { type: String, default: null },
});

const wrapperBusqueda = ref();
const buscando = ref(false);
const paramsBusqueda = reactive({
  nombre: '',
  roles: [],
});
const listaUsuarios = ref([]);

function buscarAlumnos() {
  buscando.value = true;
  const roles = paramsBusqueda.roles?.length
    ? paramsBusqueda.roles.map((r) => r.id)
    : undefined;

  const params = {
    // Para que si es un alumno nos devuelva los grupos
    info_alumno: true,
    nombre: paramsBusqueda.nombre,
    // undefined para que no lo cuente como filtro debajo y de error si no hay filtros
    rol_id: roles,
  };
  if (!compact(values(params)).length) {
    toast.info($I18n.t('error_filtros_vacios'));
    listaUsuarios.value = [];
    buscando.value = false;
    return;
  }
  const overlay = new Overlay(wrapperBusqueda.value);
  overlay.show();

  usuarios.list({ params }).then((result) => {
    listaUsuarios.value = result.data.map((usuario) => (
      new Usuario(usuario)
    ));
  }).finally(() => {
    overlay.hide();
    buscando.value = false;
  });
}
</script>

<template>
  <div id="seleccion-suscriptores-wrapper">
    <div>
      <div ref="wrapperBusqueda" class="card-busqueda">
        <form autocomplete="off" @submit.prevent="buscarAlumnos">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="control-label">{{ $t('Nombre') }}</label>
                <input
                  v-model="paramsBusqueda.nombre"
                  type="text"
                  class="form-control string required"
                >
              </div>
            </div>
          </div>
          <div class="form-actions">
            <boton-guardar :submitting="buscando" action="buscar"></boton-guardar>
          </div>
        </form>
      </div>
    </div>
    <form :action="formAction" autocomplete="off" method="post">
      <div v-if="listaUsuarios.length">
        <div class="datatable-v-scroll datatable-h-7 m-t">
          <table
            ref="tablaResultadoBusqueda"
            class="table table-striped cifra-table table-form m-t-none"
          >
            <thead>
              <tr>
                <th class="col-min"></th>
                <th>{{ $I18n.t('Nombre') }}</th>
                <th>{{ $I18n.t('Grupo') }}</th>
                <th class="nosort col-icon-1">
                  <button
                    type="button"
                    class="btn btn-xs btn-default"
                    data-controller="seleccionar-todo"
                    @click="marcarTodaBusqueda"
                  >
                    <i class="far fa-check-square"></i>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="usuario in listaUsuarios" :key="usuario.id">
                <td class="nowrap">
                  <IconosTipoUsuario :usuario="usuario"></IconosTipoUsuario>
                </td>
                <td>{{ usuario.nombreCompleto }}</td>
                <td>{{ usuario.displayGrupoPrincipal }}</td>
                <td class="text-center">
                  <div class="pretty_checkbox">
                    <div class="pretty p-icon">
                      <input
                        name="usuario_ids[]"
                        class="pretty_checkbox"
                        type="checkbox"
                        :value="usuario.id"
                      >
                      <div class="state p-cifra">
                        <i class="icon fa fa-check"></i>
                        <label class="pretty_checkbox control-label"></label>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <slot name="botones-seleccion" :usuarios="listaUsuarios"></slot>
    </form>
  </div>
</template>

<style scoped>
/* Para que no haga scroll y se vea bien el selector de estructura */
.card-busqueda {
  overflow: visible;
}
</style>
